export default __webpack_public_path__ + "static/media/bg2.3bd588dd.avif";